import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserProfileDetailsPage } from "../../modules/user-profile-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const UserProfileDetails = () => {
  const { isTenantUser, isSystemUser, activeTenantId } = useAuth();
  const location = useLocation();
  const isTenantScope =
    isTenantUser || location.pathname.startsWith("/tenant-");

  if (isSystemUser && !isTenantScope) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isSystemUser && isTenantScope && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isTenantScope && !isTenantUser ? <TenantContextBanner /> : null}
      <UserProfileDetailsPage />
    </>
  );
};

export default UserProfileDetails;
